import { useMemo } from "react";
import { useTimelineStore } from "../features/timeline";

function formatCount(count: number, singular: string, plural: string): string {
  return `${count} ${count === 1 ? singular : plural}`;
}

interface UseConversationStatsResult {
  conversationName: string | null;
  nodeCount: number;
  branchCount: number;
  metadataText: string;
}

export function useConversationStats(): UseConversationStatsResult {
  const conversationName = useTimelineStore((state) => state.conversationName);
  const timelineNodes = useTimelineStore((state) => state.nodes);
  const nodeCount = timelineNodes.size;
  const branchCount = useMemo(() => {
    let total = 0;
    timelineNodes.forEach((node) => {
      total += Math.max(node.children.length - 1, 0);
    });
    return total;
  }, [timelineNodes]);
  const metadataText = useMemo(() => {
    return `${formatCount(nodeCount, "node", "nodes")} · ${formatCount(branchCount, "branch", "branches")}`;
  }, [branchCount, nodeCount]);

  return {
    conversationName,
    nodeCount,
    branchCount,
    metadataText,
  };
}
